export let store = {
    answers: [],
    hidden: [],
    variables: [],
    calculations: []
}